import {
  DENSITY,
  RADIUS,
  SHADOW,
  TYPOGRAPHY
} from "./chunk-ZD6ZJPXY.js";

// src/colors.ts
var PRIMITIVES = {
  // Brand blue (anchored on packages-legacy/datalab-www logo `text-blue-500`)
  "blue-50": "#EFF6FF",
  "blue-100": "#DBEAFE",
  "blue-200": "#BFDBFE",
  "blue-300": "#93C5FD",
  "blue-400": "#60A5FA",
  "blue-500": "#3B82F6",
  "blue-600": "#2563EB",
  "blue-700": "#1D4ED8",
  "blue-800": "#1E40AF",
  "blue-900": "#1E3A8A",
  "blue-950": "#172554",
  // Neutral slate
  "slate-50": "#F8FAFC",
  "slate-100": "#F1F5F9",
  "slate-200": "#E2E8F0",
  "slate-300": "#CBD5E1",
  "slate-400": "#94A3B8",
  "slate-500": "#64748B",
  "slate-600": "#475569",
  "slate-700": "#334155",
  "slate-800": "#1E293B",
  "slate-900": "#0F172A",
  "slate-950": "#020617",
  // Signal
  "green-500": "#10B981",
  "green-600": "#059669",
  "amber-500": "#F59E0B",
  "amber-600": "#D97706",
  "red-500": "#EF4444",
  "red-600": "#DC2626",
  "sky-500": "#0EA5E9",
  "sky-600": "#0284C7"
};
var SEMANTIC_KEYS = [
  "surface-base",
  "surface-raised",
  "surface-sunken",
  "surface-overlay",
  "surface-brand",
  "surface-secondary",
  "surface-input",
  "text-primary",
  "text-secondary",
  "text-tertiary",
  "text-inverse",
  "text-brand",
  "stroke-subtle",
  "stroke-default",
  "stroke-strong",
  "stroke-focus",
  "accent",
  "accent-hover",
  "accent-press",
  "accent-soft",
  "signal-success",
  "signal-warning",
  "signal-danger",
  "signal-info"
];
var SEMANTICS_LIGHT = {
  "surface-base": "var(--slate-50)",
  "surface-raised": "#FFFFFF",
  "surface-sunken": "var(--slate-100)",
  "surface-overlay": "var(--slate-900)",
  "surface-brand": "var(--blue-50)",
  "surface-secondary": "var(--slate-100)",
  "surface-input": "#FFFFFF",
  "text-primary": "var(--slate-900)",
  "text-secondary": "var(--slate-600)",
  "text-tertiary": "var(--slate-400)",
  "text-inverse": "#FFFFFF",
  "text-brand": "var(--blue-700)",
  "stroke-subtle": "var(--slate-200)",
  "stroke-default": "var(--slate-300)",
  "stroke-strong": "var(--slate-500)",
  "stroke-focus": "var(--blue-500)",
  accent: "var(--blue-500)",
  "accent-hover": "var(--blue-600)",
  "accent-press": "var(--blue-700)",
  "accent-soft": "var(--blue-50)",
  "signal-success": "var(--green-500)",
  "signal-warning": "var(--amber-500)",
  "signal-danger": "var(--red-500)",
  "signal-info": "var(--sky-500)"
};
var SEMANTICS_DARK = {
  "surface-base": "var(--slate-950)",
  "surface-raised": "var(--slate-900)",
  "surface-sunken": "var(--slate-800)",
  "surface-overlay": "var(--slate-950)",
  "surface-brand": "var(--blue-950)",
  "surface-secondary": "var(--slate-800)",
  "surface-input": "var(--slate-900)",
  "text-primary": "var(--slate-50)",
  "text-secondary": "var(--slate-400)",
  "text-tertiary": "var(--slate-500)",
  "text-inverse": "var(--slate-900)",
  "text-brand": "var(--blue-300)",
  "stroke-subtle": "var(--slate-800)",
  "stroke-default": "var(--slate-700)",
  "stroke-strong": "var(--slate-500)",
  "stroke-focus": "var(--blue-400)",
  accent: "var(--blue-400)",
  "accent-hover": "var(--blue-300)",
  "accent-press": "var(--blue-500)",
  "accent-soft": "var(--blue-950)",
  "signal-success": "var(--green-500)",
  "signal-warning": "var(--amber-500)",
  "signal-danger": "var(--red-500)",
  "signal-info": "var(--sky-500)"
};

// src/charts.ts
var CHART_TOOLTIP = {
  contentStyle: {
    fontSize: 11,
    borderRadius: 6,
    border: "1px solid hsl(var(--stroke-subtle))",
    background: "hsl(var(--surface-raised))",
    color: "hsl(var(--text-primary))"
  }
};
var CHART_GRID = {
  strokeDasharray: "3 3",
  stroke: "hsl(var(--stroke-subtle))"
};
var CHART_AXIS_TICK = {
  fontSize: 10,
  fill: "hsl(var(--text-tertiary))"
};
var CHART_COLORS = [
  "hsl(var(--blue-500))",
  // 1 — brand
  "hsl(var(--sky-500))",
  // 2 — info
  "hsl(var(--amber-500))",
  // 3 — warning
  "hsl(var(--green-500))",
  // 4 — success
  "hsl(var(--red-500))",
  // 5 — danger
  "hsl(var(--blue-700))",
  // 6 — dark brand
  "hsl(var(--slate-500))",
  // 7 — neutral
  "hsl(var(--blue-300))",
  // 8 — light brand
  "hsl(var(--sky-600))",
  // 9 — dark info
  "hsl(var(--slate-700))"
  // 10 — dark neutral
];
export {
  CHART_AXIS_TICK,
  CHART_COLORS,
  CHART_GRID,
  CHART_TOOLTIP,
  DENSITY,
  PRIMITIVES,
  RADIUS,
  SEMANTICS_DARK,
  SEMANTICS_LIGHT,
  SEMANTIC_KEYS,
  SHADOW,
  TYPOGRAPHY
};
//# sourceMappingURL=index.js.map